const EMPTY_PATH = '/';

function getCanonicalFromCustomDomain(fastboot) {
  if (fastboot?.isFastBoot) {
    let request = fastboot?.request;
    let customDomain = request?.headers?.headers?.['custom-domain']?.[0];
    if (customDomain) {
      return { host: customDomain, path: request?.path || EMPTY_PATH };
    }
  }
}

function getCanonicalFromRequest(fastboot) {
  if (fastboot?.isFastBoot) {
    let request = fastboot?.request;
    return { host: request?.host, path: request?.path || EMPTY_PATH };
  }
}

function isValidTransition(transition, router, window) {
  return transition && router && transition.to && window;
}

function getRouteInfo(transition) {
  if (!transition?.to) return null;
  return {
    routeName: transition.to.name,
    params: transition.to.params,
  };
}

function buildPathFromRoute(router, routeName, params) {
  if (!routeName) return null;
  return router.urlFor(routeName, ...Object.values(params));
}

function getHostFromWindow(window) {
  return window?.location?.host;
}

function buildCanonicalResult(host, path) {
  if (host && path) {
    return { host, path };
  }
  return null;
}

function getCanonicalFromTransition(transition, router, window) {
  if (!isValidTransition(transition, router, window)) return null;

  const routeInfo = getRouteInfo(transition);
  if (!routeInfo) return null;

  const path = buildPathFromRoute(router, routeInfo.routeName, routeInfo.params);
  const host = getHostFromWindow(window);

  return buildCanonicalResult(host, path);
}

function getCanonicalFromWindow(window) {
  if (!window) return null;
  return { host: window.location.host, path: window.location.pathname };
}

function getProtocol(fastboot, window) {
  if (fastboot?.isFastBoot) {
    return 'https:'; // fastboot is not returning the secure protocol because SSR is not passing it
  }
  return window.location.protocol;
}

function stripQueryAndHash(path) {
  return path.split('?')[0].split('#')[0];
}

export default function getCanonicalUrl({ transition, fastboot, router, window }) {
  try {
    const protocol = getProtocol(fastboot, window);

    let result =
      getCanonicalFromCustomDomain(fastboot) ||
      getCanonicalFromRequest(fastboot) ||
      getCanonicalFromTransition(transition, router, window) ||
      getCanonicalFromWindow(window);

    if (!result) return;

    return stripQueryAndHash(`${protocol}//${result.host}${result.path}`);
  } catch (_) {
    // ignoring
  }
}
